import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/publicSafety/img/1.avif';
import function1 from '@src/assets/images/solution/publicSafety/img/function1.avif';
import function2 from '@src/assets/images/solution/publicSafety/img/function2.avif';
import function3 from '@src/assets/images/solution/publicSafety/img/function3.avif';
import function4 from '@src/assets/images/solution/publicSafety/img/function4.avif';
import image3 from '@src/assets/images/solution/publicSafety/img/3.avif';
import image4 from '@src/assets/images/solution/publicSafety/img/4.avif';
import image5 from '@src/assets/images/solution/publicSafety/img/5.avif';
import image6 from '@src/assets/images/solution/publicSafety/img/6.avif';
import image7 from '@src/assets/images/solution/publicSafety/img/7.avif';
import image8 from '@src/assets/images/solution/publicSafety/img/8.avif';
import image9 from '@src/assets/images/solution/publicSafety/img/9.avif';
import image10 from '@src/assets/images/solution/publicSafety/img/10.avif';

import customer1 from '@src/assets/images/solution/publicSafety/img/customer1.png';
import { publicSafety1, publicSafety2 } from '@assets/images/solution/recommendation';
import recommendation from '../common/recommendation';

export default {
  type: 'Giải pháp An toàn Đô thị',

  recommend: {
    title: '',
    desc: 'ORBRO OS là nền tảng mạnh mẽ để theo dõi vị trí theo thời gian thực và giám sát thông minh.<br/>Tích hợp trọn gói công nghệ BLE, UWB và phân tích video AI để tăng cường an toàn, hiệu quả và khả năng mở rộng trong môi trường công cộng.',
    labels: {
      desktop: [
        { img: publicSafety1, data: recommendation.loraGateway },
        { img: publicSafety2, data: recommendation.safetyBell },
      ],
      mobile: [{ data: recommendation.safetyBell }, { data: recommendation.loraGateway }, { data: recommendation.server }],
    },
  },

  banner: {
    title: 'Bảo vệ thành phố trong thời gian thực chỉ với một nút bấm',
    desc: 'Triển khai chuông an toàn công cộng để xây dựng hạ tầng và bảo vệ người dân trong thời gian thực.',
  },

  summary: {
    title: 'Xây dựng hệ thống giám sát để quản lý toàn thành phố trong tầm mắt.',
    desc: '',
    function: {
      card: [
        {
          image: function1,
          title: 'Bảng điều khiển các chỉ số vận hành theo thời gian thực',
          desc: 'Phân tích số báo cáo, số yêu cầu, tỷ lệ sử dụng, phân bố theo độ tuổi/địa lý theo thời gian thực. Tối ưu hóa ra quyết định cấp thành phố.',
        },
        {
          image: function2,
          title: 'Phân tích xu hướng theo loại yêu cầu',
          desc: 'Theo dõi số lượng yêu cầu từ hộ gia đình, cửa hàng, cơ sở theo ngày để xác định điểm cao điểm để lập kế hoạch lắp đặt.',
        },
        {
          image: function3,
          title: 'Dữ liệu theo khu vực phục vụ chiến lược không gian',
          desc: 'So sánh các khu vực theo chỉ số: số yêu cầu chuông, số người đăng ký, số vụ báo cáo, để ưu tiên khu vực cần hỗ trợ.',
        },
        {
          image: function4,
          title: 'Theo dõi quy trình từ đặt hàng đến lắp đặt',
          desc: 'Ghi nhận hệ thống từ yêu cầu, giao hàng, nhận, đến lắp đặt. Giúp kiểm tra trạng thái và giảm thiếu sót.',
        },
      ],
    },
  },

  numOfCard: {
    title: 'Chỉ số vận hành xác thực trong môi trường thực tế',
    desc: 'Số liệu phản ánh hoạt động hệ thống từ yêu cầu, lắp đặt đến báo cáo.',
    card: [
      {
        tag: '21.480 người',
        title: 'Tổng số lượt yêu cầu',
        desc: 'Số yêu cầu chuông an toàn kể từ khi ra mắt',
      },
      {
        tag: '96,7%',
        title: 'Tỷ lệ hoàn tất đăng ký',
        desc: 'Tỷ lệ đăng ký thành công sau khi nhận thiết bị',
      },
      {
        tag: '62%',
        title: 'Tỷ lệ sử dụng nút kiểm tra định kỳ',
        desc: 'Sử dụng ít nhất 1 lần/quý',
      },
    ],
  },

  func: [
    {
      theme: 'Thiết bị khẩn cấp nhỏ gọn nhưng thông minh.',
      title: 'Báo động tức thì với một nút bấm',
      desc: 'Nhấn nút để tự động gọi 112 và gửi SMS đến người thân. Ngay cả khi không có điện thoại thông minh cũng có thể kích hoạt nhanh chóng.',
      sub1: 'Độ tin cậy cao',
      icon1: IconRulerGray,
      sub2: 'Thông tin thời gian thực',
      icon2: IconClockGray,
      image: image3,
    },
    {
      title: 'Lắp đặt linh hoạt trên tường, cột hoặc cửa ra vào',
      desc: 'Thiết kế dễ gắn lên bất kỳ cấu trúc nào mà không cần điện hay thi công phức tạp.',
      sub2: 'Theo dõi vị trí theo thời gian thực',
      icon1: IconBinocularsGray,
      sub1: 'Đồng bộ dữ liệu nhanh',
      icon2: IconTvocGray,
      image: image4,
    },
    {
      title: 'Nút kiểm tra trạng thái thiết bị',
      desc: 'Nút tích hợp để kiểm tra hoạt động hàng ngày, người dùng và quản trị đều có thể xác nhận thiết bị.',
      sub1: 'Theo dõi theo thời gian thực',
      icon1: IconBinocularsGray,
      sub2: 'Độ tin cậy cao',
      icon2: IconRulerGray,
      image: image5,
    },
    {
      title: 'Thiết kế siêu tiết kiệm điện dùng cho >10 năm',
      desc: 'Thiết kế mạch tiết kiệm năng lượng giúp dùng lâu dài mà không cần thay pin.',
      sub1: 'Thiết lập vùng linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Hỗ trợ đa vùng',
      icon2: IconTagGray,
      image: image6,
    },
    {
      theme: 'Quản lý hiệu quả và tăng khả năng phản hồi bằng ứng dụng an toàn.',
      title: 'Kiểm tra và hủy yêu cầu theo thời gian thực qua app',
      desc: 'Ứng dụng hiển thị trạng thái yêu cầu và cho phép hủy trong 2 phút nếu nhấn nhầm.',
      sub1: 'Thiết lập vùng linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Hỗ trợ đa vùng',
      icon2: IconTagGray,
      image: image7,
    },
    {
      title: 'Tùy chọn người nhận cảnh báo',
      desc: 'Thiết lập nhận thông báo đến tổng đài 112, người thân, người giám hộ cùng lúc.',
      sub1: 'Thiết lập vùng linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Hỗ trợ đa vùng',
      icon2: IconTagGray,
      image: image8,
    },
    {
      title: 'Quản lý lịch sử thông báo toàn diện',
      desc: 'Ghi nhận nhật ký: báo động, hủy, kiểm tra thiết bị, pin yếu, yêu cầu thay thế... giúp theo dõi và bảo trì dễ dàng.',
      sub1: 'Thiết lập vùng linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Hỗ trợ đa vùng',
      icon2: IconTagGray,
      image: image9,
    },
    {
      title: 'Cập nhật firmware từ xa',
      desc: 'Quản trị viên có thể cập nhật firmware qua app mà không cần thiết bị bổ sung.',
      sub1: 'Thiết lập vùng linh hoạt',
      icon1: IconZoneGray,
      sub2: 'Hỗ trợ đa vùng',
      icon2: IconTagGray,
      image: image10,
    },
  ],

  customer: {
    title: 'Tại sao nhiều tổ chức chọn ORBRO?',
    card: [
      {
        logo: customer1,
        desc: '“Sau khi triển khai, việc theo dõi thời gian thực nơi nào và ai đang sử dụng rất hữu ích. Không chỉ phân phối thiết bị mà còn giúp xác định khu vực cần ưu tiên tiếp theo.”',
        name: 'Jung O‑yong, Giám đốc<br/>Chính quyền tỉnh Gyeonggi',
      },
    ],
  },

  subfunc: {
    title: 'Tóm tắt tính năng',
    desc: 'Đảm bảo an toàn giúp tăng hiệu quả và giảm thiệt hại. ORBRO cung cấp các chức năng phù hợp cho các tình huống từ khu vực nguy hiểm đến sử dụng thiết bị.',
    data: [
      {
        icon: IconLocation,
        title: 'Liên kết gọi khẩn cấp 112',
        desc: 'Nhấn nút để gọi ngay 112 và gửi SMS đến người thân.',
      },
      {
        icon: IconLocation,
        title: 'Cài đặt người nhận cảnh báo đa dạng',
        desc: 'Cùng lúc chọn tổng đài 112, người thân, bạn bè làm người nhận thông báo.',
      },
      {
        icon: IconAnalytics,
        title: 'Tính năng hủy thông báo',
        desc: 'Cho phép hủy trong 2 phút nếu nhấn nhầm, tránh báo động sai.',
      },
      {
        icon: IconSearch,
        title: 'Cập nhật firmware từ xa',
        desc: 'Cập nhật an toàn qua app mà không cần phần cứng khác.',
      },
      {
        icon: IconChartBar,
        title: 'Theo dõi pin theo thời gian thực',
        desc: 'Xem trạng thái pin và điện năng trong app.',
      },
      {
        icon: IconLayers,
        title: 'Thiết kế tiết kiệm năng lượng dài hạn',
        desc: 'Sử dụng tối đa 10 năm mà không thay pin.',
      },
      {
        icon: IconSearch,
        title: 'Nút kiểm tra hoạt động',
        desc: 'Xác nhận thiết bị hoạt động sau khi lắp đặt.',
      },
      {
        icon: IconLayers,
        title: 'Tích hợp cố định khi lắp đặt',
        desc: 'Gắn chắc vào tường hoặc cột để sử dụng ổn định.',
      },
      {
        icon: IconAnalytics,
        title: 'Chiến lược vận hành dựa trên dữ liệu',
        desc: 'Sử dụng dữ liệu hoạt động để cải thiện và lập kế hoạch.',
      },
      {
        icon: IconChartBar,
        title: 'Phân tích theo thời gian và địa điểm',
        desc: 'Cung cấp các báo cáo thống kê theo khu vực, loại và thời gian.',
      },
    ],
  },

  system: {
    title: 'Cấu hình hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Danh mục sản phẩm',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
